import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # DrugQstChoice
 *
 * 복용약 문진 선택지 모델
 */
export const DrugQstChoice = types
  .model('DrugQstChoice')
  // --------------------------------------------------------------------------
  .props({
    drugInfoSid: types.maybeNull(types.number),
    drugQstSid: types.maybeNull(types.number),
    dscrpt: types.maybeNull(types.string),
    medicineNm: types.maybeNull(types.string),
    order: types.maybeNull(types.number),
    langCd: types.maybeNull(types.string),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model drugQstChoice --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IDrugQstChoice;
      (Object.keys(newProps) as TDrugQstChoiceKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TDrugQstChoice = Instance<typeof DrugQstChoice>;
type TDrugQstChoiceSnapshot = SnapshotOut<typeof DrugQstChoice>;

export interface IDrugQstChoice extends TDrugQstChoice {}
export type TDrugQstChoiceKeys = keyof TDrugQstChoiceSnapshot & string;
export interface IDrugQstChoiceSnapshot extends TDrugQstChoiceSnapshot {}
export const createDrugQstChoice = () => types.optional(DrugQstChoice, {} as TDrugQstChoice);
